
import React, {
  useEffect,
  useState
} from "react";
import {
  getStorage,
  ref,
  getDownloadURL
} from "firebase/storage";
import {
  useParams,
  Link
} from "react-router-dom";

const API_BASE =
"https://sellerproxy-898712575285.us-central1.run.app";

export default function GalleryItem() {

  const { id } =
    useParams();

  const [item, setItem] =
    useState(null);

  const [related, setRelated] =
    useState([]);

  const [loading, setLoading] =
    useState(true);
	
	const [imageUrl, setImageUrl] =
  useState("");

const [relatedUrls, setRelatedUrls] =
  useState({});

  useEffect(() => {

    loadItem();

  }, [id]);

  const loadItem =
    async () => {
  setImageUrl("");
  setRelatedUrls({});
      try {

        const response =
          await fetch(
            `${API_BASE}/api/gallery/item/${id}`
          );

        const data =
          await response.json();

        if (!data.item) {

          setLoading(false);

          return;

        }

       setItem(data.item);

setRelated(
  data.related || []
);

const storage =
  getStorage();

if (
  data.item?.imagePaths?.[0]
) {
  const url =
    await getDownloadURL(
      ref(
        storage,
        data.item.imagePaths[0]
      )
    );

  setImageUrl(url);
}

const relatedMap = {};

for (
  const r of (
    data.related || []
  )
) {

  if (
    r.imagePaths?.[0]
  ) {

    try {

      relatedMap[r.id] =
        await getDownloadURL(
          ref(
            storage,
            r.imagePaths[0]
          )
        );

    } catch {}

  }

}

setRelatedUrls(
  relatedMap
);

        await fetch(
          `${API_BASE}/api/gallery/view/${id}`,
          {
            method: "POST"
          }
        );

      } catch (err) {

        console.error(err);

      } finally {

        setLoading(false);

      }

    };

  const likeImage =
    async () => {

      try {

        await fetch(
          `${API_BASE}/api/gallery/like/${id}`,
          {
            method: "POST"
          }
        );

        setItem(
          (prev) => ({
            ...prev,
            likes:
              (prev.likes || 0) + 1
          })
        );

      } catch (err) {

        console.error(err);

      }

    };

  const downloadImage =
    async () => {

      try {

        await fetch(
          `${API_BASE}/api/gallery/download/${id}`,
          {
            method: "POST"
          }
        );

      } catch (err) {

        console.error(err);

      }

     if (imageUrl) {
  window.open(
    imageUrl,
    "_blank"
  );
}

    };

  if (loading) {

    return (

      <div
        style={{
          padding: 30
        }}
      >
        Loading...
      </div>

    );

  }

  if (!item) {

    return (

      <div
        style={{
          padding: 30
        }}
      >
        Item not found.
      </div>

    );

  }

  return (

    <div
      style={{
        maxWidth: 1400,
        margin: "0 auto",
        padding: 20
      }}
    >

      <Link
        to="/gallery/explore"
      >
        ← Back To Gallery
      </Link>

      <div
        style={{
          display: "grid",
          gridTemplateColumns:
            "minmax(0,1fr) 380px",
          gap: 30,
          marginTop: 25
        }}
      >

        <div>

          <img
            
  src={imageUrl}
            alt={
              item.title
            }
            style={{
              width: "100%",
              borderRadius: 20
            }}
          />

        </div>

        <div>

          <h1>
            {item.title}
          </h1>

          <div
            style={{
              color:
                "#6b7280",
              marginBottom: 15
            }}
          >
            By{" "}
            {
              item.userName ||
              "PITICS Partner"
            }
          </div>

          <hr />

          <h3>
            Statistics
          </h3>

          <p>
            👁 Views:{" "}
            {item.views || 0}
          </p>

          <p>
            ❤️ Likes:{" "}
            {item.likes || 0}
          </p>

          <p>
            ⬇ Downloads:{" "}
            {item.downloads || 0}
          </p>

          <button
            onClick={
              likeImage
            }
            style={{
              marginRight: 10
            }}
          >
            ❤️ Like
          </button>

          <button
            onClick={
              downloadImage
            }
          >
            Download
          </button>

        </div>

      </div>

      <hr
        style={{
          margin:
            "40px 0"
        }}
      />

      <h2>
        Related Images
      </h2>

      {related.length === 0 && (

        <p>
          No related images found.
        </p>

      )}

      <div
        style={{
          display: "grid",
          gridTemplateColumns:
            "repeat(auto-fill,minmax(220px,1fr))",
          gap: 20
        }}
      >

        {related.map(
          (r) => (

            <Link
              key={r.id}
              to={`/gallery/item/${r.id}`}
              style={{
                textDecoration:
                  "none",
                color:
                  "inherit"
              }}
            >

              <div
                style={{
                  border:
                    "1px solid #e5e7eb",
                  borderRadius: 16,
                  overflow: "hidden",
                  background: "#fff"
                }}
              >

               <img
  src={
    relatedUrls[r.id]
  }

                  alt=""
                  style={{
                    width: "100%",
                    height: 220,
                    objectFit:
                      "cover"
                  }}
                />

                <div
                  style={{
                    padding: 12
                  }}
                >

                  <strong>
                    {r.title}
                  </strong>

                  <div
                    style={{
                      color:
                        "#6b7280",
                      marginTop: 5
                    }}
                  >
                    👁{" "}
                    {r.views || 0}
                  </div>

                </div>

              </div>

            </Link>

          )
        )}

      </div>

    </div>

  );

}

